// extracted by mini-css-extract-plugin
export default {"input":"styles_input__6V26g"};